export const ECAL_TERMS_URL = 'https://ecal.com/terms-of-use/';
export const ECAL_PRIVACY_URL = 'https://ecal.com/privacy/';

export function getOrigin () {
    const paths = {
        local: 'https://localhost:2090/',
        test: 'http://ecal-test-uniwidget-v2-ui.s3-website-us-east-1.amazonaws.com/',
        stage: 'http://ecal-test-uniwidget-v2-ui.s3-website-us-east-1.amazonaws.com/',
        prod: 'http://ecal-test-uniwidget-v2-ui.s3-website-us-east-1.amazonaws.com/',
    };
    let path = paths[window.env];
    if (!path) {
        path = paths.prod;
    }
    return path;
}

export function getOriginRoot () {
    if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
    }
    return  window.location.origin;
}

export function getURLParams () {
    return window.location.search;
}

export const ENDPOINT_HOST = {
    prod: 'https://sync.ecal.com',
    stage: 'https://staging-sync.ecal.com',
    test: 'https://testing-sync.ecal.com',
    local: 'https://testing-sync.ecal.com',
};